import { Box, CircularProgress } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageRoutes, { APIRoutes } from "../../utils/constants";
import { toast } from "react-toastify";
import HttpService from "../../hooks/Https-services";
import { useDispatch } from "react-redux";
import commonDetailSlice from "../../store/reducers/commonReducer";
import useCommonDetails from "../../Common/Hooks/useCommonDetails";
import BitMovingPlayerLiniusv2 from "./VideoCard/VideoPlayerForChannelv2";
import { V2Shell } from "@/v2/components/V2Shell";
import { PersonalChannelPage } from "@/v2/pages/PersonalChannel/PersonalChannelPage";

const PersonalChannel = ({ subscriptionDetails }: any) => {
  const navigate = useNavigate();
  const [videoList, setVideoList] = useState<any>([]);
  const [liniusAccessToken, setLiniusAccessToken] = useState({} as any);
  const [currentVideoData, setCurrentVideoData] = useState({} as any);
  const [isSkeleton, setIsSkeleton] = React.useState(true);
  const [isSkeletonList, setIsSkeletonList] = React.useState(true);
  const [currentTime, setCurrentTime] = useState(0);
  const [isDownloadAll, setIsDownloadAll] = useState(false);
  const playerRef: any = React.useRef(null);
  const [pageData, setPageData] = useState({} as any);
  const [page, setPage] = React.useState<any>(1);
  const [activeClip, setActiveClip] = useState("");
  const { id }: any = useParams();
  const [open, setOpen] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [openSharesDialog, setOpenSharesDialog] = useState(false);
  const [channelShares, setChannelShares] = useState<any[]>([]);
  const [cancellingShareId, setCancellingShareId] = useState<number | null>(null);
  const [incomingRequests, setIncomingRequests] = useState<any[]>([]);
  const [shareActionLoading, setShareActionLoading] = useState<string | null>(null);
  const dispatch = useDispatch();
  const [currentChannel, setCurrentChannel] = useState(id);
  const [currentChannelDetails, setCurrentChannelDetails] = useState(
    null as any
  );
  const userDetails = useCommonDetails();
  const [allDownloadVideo, setAllDownloadVideo] = useState([] as any);
  const [allChannels, setAllChannel] = useState([]);
  // Which channel the share / delete dialogs act on. Defaults to the channel
  // on screen; the switcher rows set it to their own channel before opening.
  const [targetChannelId, setTargetChannelId] = useState<any>(id);
  const handleClickOpen = (channelId?: any) => {
    setTargetChannelId(channelId ?? id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const findCurrentClipTime = (el: any, index: any) => {
    let sum = 0;
    for (var i = 0; i < index; i++) {
      sum += parseFloat(videoList[i].duration) + 2;
    }
    return sum;
  };
  const renderOption = (Teams: any, type: string) => {
    const query = Teams.map((el: any) => el).join(",");
    const finalQuery = `${type}=${query}`;
    return finalQuery;
  };
  const GetVideo = useCallback(async () => {
    setIsSkeletonList(true);
    try {
      if (currentChannelDetails) {
        const findChannel = currentChannelDetails;
        if (findChannel) {
          const queryForTeams =
            findChannel?.Configuration?.All?.length == 0 ||
            !findChannel?.Configuration?.All
              ? ""
              : renderOption(findChannel?.Configuration?.All, "team_ids");

          const queryForPlayer =
            findChannel?.Configuration?.Players?.length == 0 ||
            !findChannel?.Configuration?.Players
              ? ""
              : renderOption(findChannel?.Configuration?.Players, "player_ids");
          const queryForEvent =
            findChannel?.Configuration?.Events?.length == 0 ||
            !findChannel?.Configuration?.Events
              ? ""
              : renderOption(findChannel?.Configuration?.Events, "event_types");
          const queryForSeason =
            findChannel?.Configuration?.Seasons?.length == 0 ||
            !findChannel?.Configuration?.Seasons
              ? ""
              : renderOption(
                  findChannel?.Configuration?.Seasons?.map(
                    (el: any) => el.season_id
                  ),
                  "seasons"
                );
          const submitQuery = `${queryForTeams ? `${queryForTeams}` : ""}${
            queryForPlayer ? `&${queryForPlayer}` : ""
          }${queryForEvent ? `&${queryForEvent}` : ""}${
            queryForSeason ? `&${queryForSeason}` : ""
          }&page=${page}&include_total=1`;
          const res = await HttpService.getS(
            `${APIRoutes.GetAllVideoHTP}?${submitQuery}`
          );

          if (res?.data?.data) {
            setVideoList(res?.data?.data?.list);
            setPageData(res?.data?.data);
            setCurrentVideoData(res?.data?.data?.list[0]);
            setActiveClip(res?.data?.data?.list[0]?.game_event_id);
            setIsSkeleton(false);
            setIsSkeletonList(false);
            // await GetAllThumbnais(res?.data?.data);
          }
          setIsSkeleton(false);
          setIsSkeletonList(false);
        }
      }
    } catch (error: any) {
      setIsSkeleton(false);
      setIsSkeletonList(false);
      toast.error(error.response.data.message);
    }
  }, [currentChannelDetails, page]);
  useEffect(() => {
    GetVideo();
  }, [GetVideo]);
  const GetAllChannel = async (isDeleted = false) => {
    setIsSkeleton(true);
    try {
      const res = await HttpService.get(APIRoutes.GetAllChannel);
      if (isDeleted) {
        setCurrentChannel(res.data.data[0]?.ID);
        navigate(
          PageRoutes.PersonalChannel.replace(":id", res.data.data[0]?.ID)
        );
      }
      if (id == 0) {
        setCurrentChannel(res.data.data[0]?.ID);
        navigate(
          PageRoutes.PersonalChannel.replace(":id", res.data.data[0]?.ID)
        );
      }
      setAllChannel(res.data.data);
    } catch (error) {
      setIsSkeleton(false);
    }
  };
  const handlePrevious = useCallback(async () => {
    console.log("Previous");
    setPage(page - 1);
  }, [page]);
  const handleNext = useCallback(async () => {
    console.log("Next");

    setPage(page + 1);
  }, [page]);
  const GetChannelByID = async (channel_id: any) => {
    try {
      const res = await HttpService.get(
        APIRoutes.GetChannel.replace(":id", channel_id)
      );
      setCurrentChannelDetails(res.data.data);
    } catch (error) {}
  };
  const GetChannelSharesForPage = async () => {
    try {
      const res = await HttpService.get(APIRoutes.GetChannelShares);
      setChannelShares(res?.data?.data || []);
    } catch {
      setChannelShares([]);
    }
  };
  const GetMyShareRequests = async () => {
    try {
      const res = await HttpService.get(APIRoutes.GetMyShareRequests);
      setIncomingRequests(res?.data?.data || []);
    } catch {
      setIncomingRequests([]);
    }
  };
  const handleAcceptShareRequest = async (token: string) => {
    setShareActionLoading(`accept-${token}`);
    try {
      const res = await HttpService.post(
        APIRoutes.AcceptChannelShare.replace(":token", token),
        {}
      );
      toast.success("Spotlight accepted and added to your spotlights!");
      GetMyShareRequests();
      GetAllChannel(false);
      if (res?.data?.data?.channelId) {
        navigate(PageRoutes.PersonalChannel.replace(":id", res.data.data.channelId));
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to accept");
    } finally {
      setShareActionLoading(null);
    }
  };
  const handleDeclineShareRequest = async (token: string) => {
    setShareActionLoading(`decline-${token}`);
    try {
      await HttpService.post(
        APIRoutes.DeclineChannelShare.replace(":token", token),
        {}
      );
      toast.success("Share request declined");
      GetMyShareRequests();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to decline");
    } finally {
      setShareActionLoading(null);
    }
  };
  const CancelShare = async (shareId: number) => {
    setCancellingShareId(shareId);
    try {
      await HttpService.deleteData(
        APIRoutes.CancelChannelShare.replace(":shareId", String(shareId))
      );
      toast.success("Share request cancelled");
      GetChannelSharesForPage();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to cancel");
    } finally {
      setCancellingShareId(null);
    }
  };
  const GetAllLinusDownloadVideo = async () => {
    try {
      const res = await HttpService.get(APIRoutes.GetAllLinusDownloadVideo);

      setAllDownloadVideo(res.data.data);
    } catch (error) {}
  };
  async function getEntries(data: any) {
    let finalData;
    try {
      const res = await HttpService.get(APIRoutes.GetAllChannel);
      if (res.data.data == null || res.data.data.length == 0) {
        finalData = { ...data, isChannelCreated: false };
      } else {
        finalData = { ...data, isChannelCreated: true };
      }
      dispatch(commonDetailSlice.actions.removecommonDetails());
      dispatch(commonDetailSlice.actions.setcommonDetails(finalData));
    } catch (error) {
      console.log(error);
    }
  }
  const DeleteChannel = async () => {
    const deletedId = targetChannelId ?? id;
    try {
      await HttpService.deleteData(
        APIRoutes.DeleteChannel.replace(":id", String(deletedId))
      );

      if (allChannels?.length <= 1) {
        await getEntries(userDetails);

        navigate(
          PageRoutes.MyNAHLTV.replace(":id", "0").replace(":channel_id", "0")
        );
        handleClose();
      } else if (String(deletedId) === String(id)) {
        // Deleted the channel being viewed, so move to another one.
        GetAllChannel(true);
        handleClose();
      } else {
        // Deleted a different channel from the switcher: stay where we are and
        // just refresh the list, rather than being bounced to the first channel.
        GetAllChannel();
        handleClose();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id != 0) {
      GetAllLinusDownloadVideo();
      GetChannelByID(id);
      GetChannelSharesForPage();
    } else {
      setIsSkeleton(false);
    }
  }, [id, currentChannel]);
  useEffect(() => {
    GetMyShareRequests();
  }, []);
  useEffect(() => {
    if (process.env.REACT_APP_FEATURE == "true") {
      GetAllChannel(false);
    } else {
      if (process.env.REACT_APP_FEATURE !== "true") {
        navigate({
          pathname: PageRoutes.PersonalChannel.replace(":id", "0"),
          search: "?tab_id=1",
        });
      }
    }
  }, []);

  return (
    <Box sx={{ px: 2, position: "relative" }}>
      {isSkeleton ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 10,
            width: 1,
          }}
        >
          <CircularProgress
            size={48}
            sx={{
              color: "#bf311a",
            }}
          />
        </Box>
      ) : (
        <V2Shell>
          <PersonalChannelPage
            channelName={currentChannelDetails?.Configuration?.Name ?? ""}
            isShared={!!currentChannelDetails?.IsShared}
            sharedByEmail={currentChannelDetails?.SharedByEmail}
            allChannels={allChannels}
            currentChannelId={currentChannel}
            onSelectChannel={(value) => {
              setCurrentChannel(value);
              navigate(PageRoutes.PersonalChannel.replace(":id", String(value)));
            }}
            incomingRequestsCount={incomingRequests.length}
            onOpenSharesDialog={() => setOpenSharesDialog(true)}
            onAddChannel={() =>
              navigate(
                PageRoutes.MyNAHLTV.replace(":id", "1").replace(":channel_id", "0")
              )
            }
            onEditChannel={(channelId) =>
              navigate(
                PageRoutes.MyNAHLTV.replace(":id", "1").replace(
                  ":channel_id",
                  String(channelId ?? id)
                )
              )
            }
            onDeleteChannel={(channelId) => handleClickOpen(channelId)}
            onShareChannel={(channelId) => {
              setTargetChannelId(channelId ?? id);
              setOpenShare(true);
            }}
            videoList={videoList}
            page={page}
            pageData={pageData}
            isSkeletonList={isSkeletonList}
            activeClip={activeClip}
            onSelectClip={(clip, index) => {
              playerRef.current.seek(findCurrentClipTime(clip, index));
            }}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            currentVideoData={currentVideoData}
            videoPlayer={
              <BitMovingPlayerLiniusv2
                sort={true}
                accessToken={liniusAccessToken?.accessToken}
                page={page}
                pageData={pageData}
                setActiveClip={setActiveClip}
                setPage={setPage}
                setCurrentTime={setCurrentTime}
                playerRef={playerRef}
                currentVideoData={currentVideoData}
                setCurrentVideoData={setCurrentVideoData}
                videoList={videoList}
                videoUrl={""}
                setRunning={undefined}
                autoPlay={false}
                setIsSeeking={undefined}
                checked={false}
                handleChangeIconAction={undefined}
                videoClipsData={pageData}
              />
            }
            allDownloadVideo={allDownloadVideo}
            isDownloadAll={isDownloadAll}
            setIsDownloadAll={setIsDownloadAll}
            subscriptionDetails={subscriptionDetails}
            userDetails={userDetails}
            onDownloadRequested={GetAllLinusDownloadVideo}
            deleteDialogOpen={open}
            onCloseDeleteDialog={handleClose}
            onConfirmDelete={DeleteChannel}
            shareDialogOpen={openShare}
            onCloseShareDialog={() => {
              setOpenShare(false);
              GetChannelSharesForPage();
            }}
            channelIdForShare={targetChannelId}
            targetChannelName={
              String(targetChannelId) === String(id)
                ? currentChannelDetails?.Configuration?.Name ?? ""
                : (allChannels as any[]).find(
                    (channel: any) =>
                      String(channel.ID) === String(targetChannelId)
                  )?.Configuration?.Name ?? ""
            }
            sharesDialogOpen={openSharesDialog}
            onCloseSharesDialog={() => setOpenSharesDialog(false)}
            incomingRequests={incomingRequests}
            shareActionLoading={shareActionLoading}
            onAcceptShare={handleAcceptShareRequest}
            onDeclineShare={handleDeclineShareRequest}
            onRefreshIncomingShares={GetMyShareRequests}
            onRefreshChannelShares={() => GetChannelSharesForPage()}
            channelShares={channelShares}
            cancellingShareId={cancellingShareId}
            onCancelShare={CancelShare}
          />
        </V2Shell>
      )}
    </Box>
  );
};

export default PersonalChannel;
